'use client';

import { EmptyValue } from './empty-value';

interface SelectValueProps {
  value: string;
  options: { id: string; label: string }[];
}

export function SelectValue({ value, options }: SelectValueProps) {
  const option = options.find(opt => opt.id === value);

  if (!option) {
    return <EmptyValue message="Non sélectionné" />;
  }

  return <span className="text-[13px] font-semibold text-foreground">{option.label}</span>;
}

